import { render, staticRenderFns } from "./editSkuaAwait.vue?vue&type=template&id=5b2ea4f6&scoped=true&"
import script from "./editSkuaAwait.vue?vue&type=script&lang=js&"
export * from "./editSkuaAwait.vue?vue&type=script&lang=js&"
import style0 from "./editSkuaAwait.vue?vue&type=style&index=0&id=5b2ea4f6&prod&lang=less&scoped=true&"
import style1 from "./editSkuaAwait.vue?vue&type=style&index=1&id=5b2ea4f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ea4f6",
  null
  
)

export default component.exports